import { render, staticRenderFns } from "./CreateBankAccountCard.vue?vue&type=template&id=264992b9&scoped=true&"
import script from "./CreateBankAccountCard.vue?vue&type=script&lang=js&"
export * from "./CreateBankAccountCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateBankAccountCard.vue?vue&type=style&index=0&id=264992b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264992b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VDivider,VFooter,VIcon,VSpacer})
